import React from 'react'
import { observer } from 'mobx-react'
import GroupedValuesPane from '../components/GroupedValuesPane'
import ApiClientFactory from '../api/ApiClientFactory'
import { getRelUrl } from '../common/Util'
import AppStateStore from '../stores/AppStateStore'
import { CommonContext } from '../CommonContext'
import {StatementsContainer} from "../styles/Container.styles";

const HelpView = observer(class HelpView extends React.Component {
  componentDidMount (): void {
    AppStateStore.activeView = 'Help'
  }

  private getGroupedValues = async (url: string) => {
    return ApiClientFactory.getInstance()
      .get(url)
  }

  render () {
    return <CommonContext.Consumer>
      {data => <StatementsContainer>
        <GroupedValuesPane hasTitles adapter={this.getGroupedValues(getRelUrl(data.commonData.links, data.commonData.help.rel))}/>
      </StatementsContainer>}
    </CommonContext.Consumer>
  }
});

export default HelpView
